import axios from 'axios';
import { API_URL } from './config';

/**
 * Servicio para migrar datos desde localStorage a PostgreSQL
 */
const migrationService = {
  /**
   * Migra las cuentas desde localStorage a PostgreSQL
   * @returns {Promise<Object>} Resultado de la migración
   */
  migrateAccountsFromLocalStorage: async () => {
    try {
      // Obtener el token del usuario
      const token = sessionStorage.getItem('token');
      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      // Configuración de axios con el token
      const config = {
        headers: {
          Authorization: `Bearer ${token}`
        }
      };

      // Verificar si ya existe la marca de migración para evitar migrar múltiples veces
      const migrationCompleted = localStorage.getItem('accountsMigrationCompleted');
      if (migrationCompleted === 'true') {
        console.log('La migración de cuentas ya se ha completado previamente');
        return { success: true, message: 'La migración ya estaba completa', newAccounts: [] };
      }

      // Obtener cuentas de financialData (desde onboarding)
      const financialData = localStorage.getItem('financialData');
      if (!financialData) {
        console.log('No se encontraron datos financieros en localStorage');
        return { success: true, message: 'No hay datos para migrar', newAccounts: [] };
      }

      const parsedData = JSON.parse(financialData);
      const accounts = parsedData.newAccounts || [];
      
      if (accounts.length === 0) {
        console.log('No hay cuentas para migrar');
        localStorage.setItem('accountsMigrationCompleted', 'true');
        return { success: true, message: 'No hay cuentas para migrar', newAccounts: [] };
      }

      console.log(`Migrando ${accounts.length} cuentas desde localStorage...`);
      
      // Array para almacenar los resultados de la migración
      const migrationResults = [];
      
      // Migrar cada cuenta
      for (const account of accounts) {
        try {
          const accountData = {
            nombre: account.nombre,
            tipo: account.tipo,
            entidad: account.entidad,
            balance: account.balance,
            moneda: account.moneda
          };
          
          // Enviar la cuenta al servidor
          const response = await axios.post(
            `${API_URL}/api/v1/dashboard/accounts`, 
            accountData, 
            config
          );
          
          migrationResults.push({
            success: true,
            originalAccount: account,
            newAccount: response.data.data
          });
          
          console.log(`Cuenta migrada exitosamente: ${account.nombre}`);
        } catch (error) {
          console.error(`Error migrando cuenta ${account.nombre}:`, error);
          migrationResults.push({
            success: false,
            originalAccount: account,
            error: error.message
          });
        }
      }
      
      // Marcar la migración como completada
      localStorage.setItem('accountsMigrationCompleted', 'true');
      
      return { 
        success: true, 
        message: `Migración completada. ${migrationResults.filter(r => r.success).length} de ${accounts.length} cuentas migradas exitosamente.`,
        results: migrationResults
      };
    } catch (error) {
      console.error('Error durante la migración de cuentas:', error);
      return { success: false, message: 'Error durante la migración', error: error.message };
    }
  }
};

export default migrationService;
